import React from 'react';
import { Flex, Link, Text } from '@chakra-ui/react';
import { ChevronLeft24 } from '@carbon/icons-react';
import { SdgItemWithIndicators } from './SdgItemWithIndicators';
import { QuestionsForm } from './QuestionsForm';
import { FormData } from './SdgQuiz';
import { IndicatorsAccordion } from './IndicatorsAccordion';
import { SdgImageContainer } from './SdgImageContainer';
import contentJson from '../utils/content.json';
import { useResponsive } from '#core/SdgQuiz/utils';

const content: any = contentJson;

export type QuestionPageProps = {
  sdgNumber: number;
  data: Object;
  updateFields: (fields: Partial<FormData>) => void;
  handleNext: () => void;
  handleBack: () => void;
};

export const QuestionPage = ({
  sdgNumber,
  data,
  updateFields,
  handleNext,
  handleBack,
}: QuestionPageProps) => {
  const currentContent = content[`sdg${sdgNumber}`];

  const isMobileScreen = useResponsive();

  return (
    <Flex
      maxW="50rem"
      w="100%"
      justifyContent="space-between"
      flexDirection={isMobileScreen ? 'column' : 'row'}
    >
      {isMobileScreen && sdgNumber > 1 ? (
        <Link onClick={handleBack} textDecoration="underline" mb={5}>
          {' '}
          <Flex alignItems="center">
            <ChevronLeft24 />
            Back to SDG {sdgNumber - 1}
          </Flex>
        </Link>
      ) : null}

      {isMobileScreen ? (
        <IndicatorsAccordion sdgNumber={sdgNumber} />
      ) : (
        <Flex flexDir="column" maxW="12rem">
          <SdgImageContainer
            bgPosition={
              isMobileScreen
                ? currentContent.imgSpritePositionMobileLarge
                : currentContent.imgSpritePositionDesktop
            }
            bgSize={content.imgContainerSizes.imgSizeDesktop}
            imgHeight={content.imgContainerSizes.imgSideDesktop}
            imgWidth={content.imgContainerSizes.imgSideDesktop}
          />

          <Text fontWeight="bold" my={4}>
            Data that will be required from your institution
          </Text>

          <SdgItemWithIndicators sdgNumber={sdgNumber} />
        </Flex>
      )}

      <QuestionsForm
        data={data}
        sdgNumber={sdgNumber}
        updateFields={updateFields}
        handleNext={handleNext}
        handleBack={handleBack}
      />
    </Flex>
  );
};
